import { isEqual } from "lodash";

import { Stem, StemOrder } from "@examspark/types";

import { getNewScore } from "./utils";

export const scoreSequence = (expected: StemOrder, actual: Stem.Response) => {
  const score = getNewScore();
  const { scoring } = expected;

  score.max = 1;

  if (!actual?.order) {
    return score;
  }

  if (isEqual(actual.order, scoring?.order)) {
    score.actual = 1;
  }

  return score;
};
